import React, { Component } from "react";
import {
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBRow,
    MDBCol,
    MDBBtn,
    toast,
} from "mdbreact";
import VenueUnitSubscribersTable from "../../../components/NetworkMgmt/Venues/Datatables/VenueUnitSubscriberTable";
import ModifyResident from "../../../components/VenueMgmt/Forms/ModifyResident/ModifyResident";
import ModifyGuest from "../../../components/VenueMgmt/Forms/ModifyGuest/ModifyGuest";
import { withTranslation } from "react-i18next";
import axios from "../../../axios";
class ViewVenueUnitSubscribers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            loading: false,
            unitSubscriptionsList: this.props.unitSubscriptionsList,
        };
    }
    toggleModifyResident = () => {
        this.setState({
            modalModifyResident: !this.state.modalModifyResident,
        });
    };
    toggleModifyGuest = () => {
     this.setState({
         modalModifyGuest: !this.state.modalModifyGuest,
     });
    };
    toggleModifyService = () => {
        this.setState({
            modalModifyServiceInfo: !this.state.modalModifyServiceInfo,
        });
    };
    getVenueDetails = (index, guest) => {
        this.setState({ loadingVenueDetails: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: index,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        this.setState({
            unitSubscriptionsList: undefined,
        });
        axios
            .post("/networkoperatorconsole/venues/listVenueDetails", body, {
                headers: {},
            })
            .then((response) => {
                let subscriptionList = [];
                !guest ?
                    subscriptionList.push(response.data[index][
                        "Units-Building-Floor-List-Subscribers"
                    ][this.state.UnitID][this.state.UnitBuilding][
                        this.state.UnitFloor
                    ]["Subscriptions"]) :
                    subscriptionList.push(response.data[index][
                        "Units-Building-Floor-List-GuestNetworks"
                    ][this.state.UnitID][this.state.UnitBuilding][
                        this.state.UnitFloor
                    ]["Subscriptions"]);

                this.setState({
                    unitSubscriptionsList: subscriptionList
                });
            })
            .catch((error) => {
                this.setState({ error: true });
                this.setState({ loadingVenueDetails: false });
            });
    };
    modifyResident = (key) => {
        this.setState({
            modalModifyResident: !this.state.modalModifyResident,
            recentResidents: this.props.recentResidents,
        });
        this.setState({
            SubscriberGivenName: key.SubscriberGivenName,
            SubscriberFamilyName: key.SubscriberFamilyName,
            SubscriberEmail: key.SubscriberEmail,
            SubscriberPhoneNumber: key["SubscriberPhoneNumber.E164"].toString(),
            contactpref_email: key.contactpref_email,
            contactpref_sms: key.contactpref_sms,
            SubscriberLocale: key.SubscriberLocale,
            UnitFloor: key.UnitFloor,
            UnitBuilding: key.UnitBuilding,
            StartDateTime: key["StartDateTimeUTC.ISO8601"],
            EndDateTime: key["EndDateTimeUTC.ISO8601"],
            UnitID: key.UnitID,
            ssid: key.ssid,
            unitID_internal: key.UnitID_internal,
            servicePlanID: key.ServicePlan["ServicePlanID"],
            servicePlan: key.ServicePlan["ServicePlanName"],
            vlan: key.vlan,
            status: key.Status,
            PMS: key["PMS"],
            subscriberManagedviaSSO: key["SubscriberManagedviaSSO"],
            StripeClientSecret: key["StripeClientSecret"],
            paymentFailed: key["paymentFailed"],
            subscriberToken: key.SubscriberToken,
            RealPageUnitID: key.RealPageUnitID,
            country: key["Country.ISO3166A3"],
            subscriptionDiscount: key["VenueUnitShoppingCartPriceAdjustment"] / 100,
            venueDiscount: key["VenuePriceAdjustment"] / 100,
            externalSubscriberID: key["externalSubscriberID"],
            selectedServicePlanPrice: key["ListBillingCyclePrice"],
            stripeClientParentSecret: key["StripeClientSecret"],
            setupIntentID: key["SetupIntentId"],
        });
    };
    modifyGuest = (key) => {
     this.setState({
         modalModifyGuest: !this.state.modalModifyGuest,
         recentResidents: this.props.recentResidents,
     });
     this.setState({
         SubscriberGivenName: key.SubscriberGivenName,
         SubscriberFamilyName: key.SubscriberFamilyName,
         SubscriberEmail: key.SubscriberEmail,
         SubscriberPhoneNumber: key["SubscriberPhoneNumber.E164"].toString(),
         contactpref_email: key.contactpref_email,
         contactpref_sms: key.contactpref_sms,
         SubscriberLocale: key.SubscriberLocale,
         UnitFloor: key.UnitFloor,
         UnitBuilding: key.UnitBuilding,
         StartDateTime: key["StartDateTimeUTC.ISO8601"],
         EndDateTime: key["EndDateTimeUTC.ISO8601"],
         UnitID: key.UnitID,
         ssid: key.ssid,
         unitID_internal: key.UnitID_internal,
         servicePlanID: key.ServicePlan["ServicePlanID"],
         servicePlan: key.ServicePlan["ServicePlanName"],
         vlan: key.vlan,
         status: key.Status,
         PMS: key["PMS"],
         subscriberManagedviaSSO: key["SubscriberManagedviaSSO"],
         StripeClientSecret: key["StripeClientSecret"],
         paymentFailed: key["paymentFailed"],
         subscriberToken: key.SubscriberToken,
         RealPageUnitID: key.RealPageUnitID,
         country: key["Country.ISO3166A3"],
         subscriptionDiscount: key["VenueUnitShoppingCartPriceAdjustment"] / 100,
         venueDiscount: key["VenuePriceAdjustment"] / 100,
         externalSubscriberID: key["externalSubscriberID"],
         selectedServicePlanPrice: key["ListBillingCyclePrice"],
         stripeClientParentSecret: key["StripeClientSecret"],
         setupIntentID: key["SetupIntentId"],
     });
 };
    submitModify = (
        email,
        firstName,
        lastName,
        phoneNumber,
        language,
        contactpref_email,
        contactpref_sms,
        recentResidents,
        dateStart,
        oldDateStart,
        dateEnd,
        oldDateEnd,
        venueID,
        unitID,
        building,
        floor,
        servicePlanID,
        isUpdated,
        isUpdatedServicePlan,
        isUpdatedStartDate,
        isUpdatedEndDate,
        isUpdatedSubscriptionDiscount,
        unitID_internal,
        selectedServicePlanName,
        subscriberToken,
        updatedUnit,
        subscriptionDiscount,
        setupIntentID,
        guest
    ) => {
        this.setState({ loading: true });
        let bodyDateStart = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            VenueID: venueID,
            UnitID_internal: unitID_internal,
            "StartDateTimeUTC.ISO8601": oldDateStart && !isNaN(new Date(oldDateStart).getTime())
                ? new Date(oldDateStart).toISOString().replace(/:00.\d+Z$/g, "Z")
                : new Date().toISOString().replace(/:00.\d+Z$/g, "Z"),
            "NewStartDateTimeUTC.ISO8601": dateStart && !isNaN(new Date(dateStart).getTime())
                ? new Date(dateStart).toISOString().replace(/:00.\d+Z$/g, "Z")
                : new Date().toISOString().replace(/:00.\d+Z$/g, "Z"),
            UserTimeZone: new Date().getTimezoneOffset(),
            SubscriberToken: subscriberToken,
        };
        let bodyDateEnd = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            VenueID: venueID,
            UnitID_internal: unitID_internal,
            "StartDateTimeUTC.ISO8601": oldDateStart && !isNaN(new Date(oldDateStart).getTime())
                ? new Date(oldDateStart).toISOString()
                : new Date().toISOString(),
            "NewEndDateTimeUTC.ISO8601":
                dateEnd && !isNaN(new Date(dateEnd).getTime())
                    ? new Date(dateEnd).toISOString().replace(/:00.\d+Z$/g, "Z")
                    : undefined,
            UserTimeZone: new Date().getTimezoneOffset(),
            SubscriberToken: subscriberToken,
        };
        let bodyServicePlan = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            VenueID: venueID,
            UnitID_internal: unitID_internal,
            "CurrentStartDateTimeUTC.ISO8601": oldDateStart && !isNaN(new Date(oldDateStart).getTime())
                ? new Date(oldDateStart).toISOString()
                : new Date().toISOString(),
            NewServicePlanID: servicePlanID,
            UserTimeZone: new Date().getTimezoneOffset(),
            SubscriberToken: subscriberToken,
        };
        let bodyUpdatePII = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            GivenName: firstName,
            FamilyName: lastName,
            "PhoneNumber.E164": phoneNumber,
            locale: language,
            contactpref_email: true,
            contactpref_sms: contactpref_sms,
            VenueID: venueID,
            SubscriberToken: subscriberToken,
        };
        let bodyUpdateUnit = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            StripeClientSecret: sessionStorage.getItem(
                "stripeClientSecretSubscriber"
            ),
            SetupIntentId: setupIntentID,
            NewUnitID_internal: unitID_internal,
            VenueID: venueID,
        };
        let bodyUpdateSubscriberPrice = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            StripeClientSecret: sessionStorage.getItem(
                "stripeClientSecretSubscriber"
            ),
            SetupIntentId: "",
            VenueID: venueID,
            NewVenueUnitPriceAdjustment: -Math.abs(subscriptionDiscount) * 100,
            "NewEndDateTimeUTC.ISO8601":
                dateEnd && !isNaN(new Date(dateEnd).getTime())
                    ? new Date(dateEnd).toISOString().replace(/:00.\d+Z$/g, "Z")
                    : "",
        };
        Promise.all([
            dateStart && !isNaN(new Date(dateStart).getTime()) && new Date(dateStart).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0) && isUpdatedStartDate === true
                ? axios.post(
                      "/networkoperatorconsole/subscribers/resetSubscriptionStartDate",
                      bodyDateStart,
                      { headers: {} }
                  )
                : console.log(
                      "🚀 ~ file: ViewVenueUnitSubscriptions.js:188 ~ ViewVenueUnitSubscribers ~ No Date Start Change"
                  ),
            isUpdatedEndDate === true
                ? axios.post(
                      "/networkoperatorconsole/subscribers/resetSubscriptionEndDate",
                      bodyDateEnd,
                      { headers: {} }
                  )
                : console.log(
                      "🚀 ~ file: ViewVenueUnitSubscriptions.js:196 ~ ViewVenueUnitSubscribers ~ No PII Updates"
                  ),
            isUpdated === true
                ? axios.post(
                      "/networkoperatorconsole/subscribers/updateSubscriberPII",
                      bodyUpdatePII,
                      { headers: {} }
                  )
                : console.log(
                      "🚀 ~ file: ViewVenueUnitSubscriptions.js:204 ~ ViewVenueUnitSubscribers ~ No Change"
                  ),
            isUpdatedServicePlan === true
                ? axios.post(
                      "/networkoperatorconsole/subscribers/modifyServicePlan",
                      bodyServicePlan,
                      { headers: {} }
                  )
                : console.log(
                      "🚀 ~ file: ViewVenueUnitSubscriptions.js:212 ~ ViewVenueUnitSubscribers ~ No Service Plan Updates"
                  ),
            updatedUnit === true
                ? axios.post(
                      "/networkoperatorconsole/subscribers/modifyVenueUnit",
                      bodyUpdateUnit,
                      { headers: {} }
                  )
                : console.log(
                      "🚀 ~ file: ViewVenueSubscribers.js:229 ~ ViewVenueSubscribers ~ bodyUpdateUnit"
                  ),
            isUpdatedSubscriptionDiscount === true
                ? axios.post(
                      "/venuemgmtconsole/subscribers/modifySubscriptionPrice",
                      bodyUpdateSubscriberPrice,
                      { headers: {} }
                  )
                : console.log(
                      "🚀 ~ file: ViewVenueSubscribers.js:229 ~ ViewVenueSubscribers ~ No Price Updates"
                  ),
        ])
            .then(async ([res1, res2, res3, res4, res5, res6]) => {
                toast.success("Updated Resident!", {
                    closeButton: false,
                });
                guest === true ? this.toggleModifyGuest() : this.toggleModifyResident();
                // this.toggleModifyResident();
                this.setState({ activeData: undefined });
                this.getVenueDetails(venueID, guest);
                if (isUpdatedServicePlan === true) {
                    this.setState({
                        loading: false,
                        nextInvoiceAdjustedAmount:
                            res4.data["NextInvoiceAdjustedAmount.USD"] ===
                            undefined
                                ? ""
                                : res4.data["NextInvoiceAdjustedAmount.USD"] /
                                  100,
                        nextInvoiceDate:
                            res4.data["NextInvoiceDateTimeUTC.ISO8601"],
                        billingCycleAdjustment:
                            res4.data["BillingCyclePriceAdjustment"] ===
                            undefined
                                ? ""
                                : res4.data["BillingCyclePriceAdjustment"] /
                                  100,
                        subscriberName: firstName + " " + lastName,
                        subscriberEmail: email,
                        newServicePlanName: selectedServicePlanName,
                        servicePlanID: servicePlanID,
                        paymentFailed: res4.data["paymentFailed"],
                    });
                    sessionStorage.setItem(
                        "servicePlanIDSubscriber",
                        servicePlanID
                    );
                    this.toggleModifyService();
                }
                this.setState({
                    loading: false,
                });
            })
            .catch((error) => {
                toast.error(error.response.data.message, {
                    closeButton: false,
                });
                guest === true ? this.toggleModifyGuest() : this.toggleModifyResident();
                // this.toggleModifyResident();
                this.setState({ recentResidents: recentResidents });
                this.setState({ loading: false });
            });
    };
    deleteResident = (
        email,
        venueID,
        unitID,
        building,
        floor,
        recentResidents,
        oldDateStart,
        unitID_internal,
        cancellationReason,
        refundAmount,
        guest
    ) => {
        this.setState({ loadingDelete: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            VenueID: venueID,
            UnitID_internal: unitID_internal,
            endImmediately: true,
            "StartDateTimeUTC.ISO8601": oldDateStart && !isNaN(new Date(oldDateStart).getTime())
                ? new Date(oldDateStart).toISOString()
                : new Date().toISOString(),
            UserTimeZone: new Date().getTimezoneOffset(),
            CancellationReasons: cancellationReason,
            requestedRefundAmount: refundAmount,
        };
        // console.log(guest)
        axios
            .post(
                "/networkoperatorconsole/subscribers/resetSubscriptionEndDate",
                body,
                {
                    headers: {},
                }
            )
            .then((response) => {
                toast.success("Deleted Resident!", {
                    closeButton: false,
                });
                guest === true ? this.toggleModifyGuest() : this.toggleModifyResident();
                this.getVenueDetails(this.props.venueID, this.props.venueName);
                this.setState({ loadingDelete: false });
            })
            .catch((error) => {
                toast.error("There was an error!", {
                    closeButton: false,
                });
                this.setState({ error: true });
                this.setState({ loadingDelete: false });
            });
    };
    render() {
     // console.log(this.props.unitSubscriptionsList)
        return (
            <>
                <MDBModal
                    isOpen={this.state.modalModifyServiceInfo}
                    toggle={this.toggle}
                    size="md"
                    className="form"
                    centered
                >
                    <MDBModalHeader
                        toggle={
                            this.state.paymentFailed
                                ? ""
                                : this.toggleModifyService
                        }
                    >
                        <h4>Modified Service Information</h4>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <div>
                            <MDBRow>
                                <MDBCol sm="6" lg="4">
                                    <p>Subscriber:</p>
                                </MDBCol>
                                <MDBCol sm="6" lg="8">
                                    {this.state.subscriberName}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="6" lg="4">
                                    <p>Email:</p>
                                </MDBCol>
                                <MDBCol sm="6" lg="8">
                                    {this.state.subscriberEmail}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="6" lg="4">
                                    <p>New Service Plan:</p>
                                </MDBCol>
                                <MDBCol sm="6" lg="8">
                                    {this.state.newServicePlanName}
                                </MDBCol>
                            </MDBRow>
                            {this.state.nextInvoiceDate !== undefined ? (
                                <>
                                    <MDBRow>
                                        <MDBCol sm="6" lg="4">
                                            <p>Next Invoice Date:</p>
                                        </MDBCol>
                                        <MDBCol sm="6" lg="8">
                                            {this.state.nextInvoiceDate !==
                                            undefined
                                                ? Intl.DateTimeFormat("en-US", {
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                  }).format(
                                                      new Date(
                                                          this.state.nextInvoiceDate
                                                      )
                                                  )
                                                : ""}
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol sm="6" lg="4">
                                            <p>Next Invoice Amount:</p>
                                        </MDBCol>
                                        <MDBCol sm="6" lg="8">
                                            $
                                            {
                                                this.state
                                                    .nextInvoiceAdjustedAmount
                                            }
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow className="align-items-end">
                                        <MDBCol sm="6" lg="4">
                                            <p>
                                                Billing Cycle Adjustment Amount:
                                            </p>
                                        </MDBCol>
                                        <MDBCol sm="6" lg="8">
                                            ${this.state.billingCycleAdjustment}
                                        </MDBCol>
                                    </MDBRow>
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        {this.state.paymentFailed ? (
                            <MDBBtn
                                color="danger"
                                className="btn Ripple-parent btn-default centered upgradePlan"
                                href={
                                    "/update/checkout?ui=" +
                                    window.location.pathname.slice(1)
                                }
                            >
                                Modify Billing CC
                            </MDBBtn>
                        ) : (
                            <MDBBtn
                                color="danger"
                                onClick={this.toggleModifyService}
                                type="submit"
                            >
                                OK
                            </MDBBtn>
                        )}
                    </MDBModalFooter>
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalModifyResident}
                    toggle={this.toggle}
                    size="fluid"
                    className="form"
                >
                    <ModifyResident
                        toggleModifyResident={this.toggleModifyResident}
                        firstName={this.state.SubscriberGivenName}
                        lastName={this.state.SubscriberFamilyName}
                        email={this.state.SubscriberEmail}
                        phoneNumber={this.state.SubscriberPhoneNumber}
                        receivetext={this.state.contactpref_email}
                        receivephone={this.state.contactpref_sms}
                        contactpref_sms={this.state.contactpref_sms}
                        contactpref_email={this.state.contactpref_email}
                        language={this.state.SubscriberLocale}
                        floor={this.state.UnitFloor}
                        building={this.state.UnitBuilding}
                        startDate={this.state.StartDateTime}
                        endDate={this.state.EndDateTime}
                        unitID={this.state.UnitID}
                        submitModify={this.submitModify}
                        venueID={this.props.venueID}
                        updateName={this.props.updateName}
                        loading={this.state.loading}
                        SSID={this.state.ssid}
                        unitID_internal={this.state.unitID_internal}
                        servicePlanID={this.state.servicePlanID}
                        servicePlan={this.state.servicePlan}
                        submitDelete={this.deleteResident}
                        availablePlans={this.props.availablePlans}
                        vlan={this.state.vlan}
                        status={this.state.status}
                        loadingDelete={this.state.loadingDelete}
                        PMS={this.state.PMS}
                        subscriberManagedviaSSO={
                            this.state.subscriberManagedviaSSO
                        }
                        StripeClientSecret={this.state.StripeClientSecret}
                        paymentFailed={this.state.paymentFailed}
                        subscriberToken={this.state.subscriberToken}
                        RealPageUnitID={this.state.RealPageUnitID}
                        country={this.state.country}
                        subscriptionDiscount={this.state.subscriptionDiscount}
                        venueDiscount={this.state.venueDiscount}
                        externalSubscriberID={this.state.externalSubscriberID}
                        selectedServicePlanPrice={
                            this.state.selectedServicePlanPrice
                        }
                        stripeClientParentSecret={
                            this.state.stripeClientParentSecret
                        }
                        setupIntentID={this.state.setupIntentID}
                        showUpdate={this.props.showUpdate}
                        cancelInputType={this.props.cancelInputType}
                        keypoolList={this.props.keypoolList}
                        getVenueDetails={this.getVenueDetails}
                        isVenuePMSConfigured={this.props.isVenuePMSConfigured}
                    />
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalModifyGuest}
                    toggle={this.toggle}
                    size="fluid"
                    className="form"
                >
                    <ModifyGuest
                        toggleModifyResident={this.toggleModifyGuest}
                        firstName={this.state.SubscriberGivenName}
                        lastName={this.state.SubscriberFamilyName}
                        email={this.state.SubscriberEmail}
                        phoneNumber={this.state.SubscriberPhoneNumber}
                        receivetext={this.state.contactpref_email}
                        receivephone={this.state.contactpref_sms}
                        contactpref_sms={this.state.contactpref_sms}
                        contactpref_email={this.state.contactpref_email}
                        language={this.state.SubscriberLocale}
                        floor={this.state.UnitFloor}
                        building={this.state.UnitBuilding}
                        startDate={this.state.StartDateTime}
                        endDate={this.state.EndDateTime}
                        unitID={this.state.UnitID}
                        submitModify={this.submitModify}
                        venueID={this.props.venueID}
                        updateName={this.props.updateName}
                        loading={this.state.loading}
                        SSID={this.state.ssid}
                        unitID_internal={this.state.unitID_internal}
                        servicePlanID={this.state.servicePlanID}
                        servicePlan={this.state.servicePlan}
                        submitDelete={this.deleteResident}
                        availablePlans={this.props.availablePlans}
                        vlan={this.state.vlan}
                        status={this.state.status}
                        loadingDelete={this.state.loadingDelete}
                        PMS={this.state.PMS}
                        subscriberManagedviaSSO={
                            this.state.subscriberManagedviaSSO
                        }
                        StripeClientSecret={this.state.StripeClientSecret}
                        paymentFailed={this.state.paymentFailed}
                        subscriberToken={this.state.subscriberToken}
                        RealPageUnitID={this.state.RealPageUnitID}
                        country={this.state.country}
                        subscriptionDiscount={this.state.subscriptionDiscount}
                        venueDiscount={this.state.venueDiscount}
                        externalSubscriberID={this.state.externalSubscriberID}
                        selectedServicePlanPrice={
                            this.state.selectedServicePlanPrice
                        }
                        stripeClientParentSecret={
                            this.state.stripeClientParentSecret
                        }
                        setupIntentID={this.state.setupIntentID}
                        showUpdate={this.props.showUpdate}
                        cancelInputType={this.props.cancelInputType}
                        keypoolList={this.props.keypoolList}
                    />
                </MDBModal>
                    <>
                        <VenueUnitSubscribersTable
                            modifyResident={this.modifyResident}
                            modifyGuest={this.modifyGuest}
                            unitSubscriptionsList={
                                this.state.unitSubscriptionsList
                            }
                            getSubscriptionList={this.props.getSubscriptionList}
                            refreshed={this.props.refreshed}
                            updateName={this.props.updateName}
                        />
                    </>
            </>
        );
    }
}
export default withTranslation()(ViewVenueUnitSubscribers);
